import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from '@/components/HomePage'
import ProductsPage from '@/components/ProductsPage'
import WordPressIntegrationPage from '@/components/WordPressIntegrationPage'
import ElementorPage from '@/components/ElementorPage'
import CpanelPage from '@/components/CpanelPage'
import DiscordNotificationPage from '@/components/DiscordNotificationPage'
import StripePaymentPage from '@/components/StripePaymentPage'
import CryptoPaymentPage from '@/components/CryptoPaymentPage'
import BlogPage from '@/components/BlogPage'
import BlogPostPage from '@/components/BlogPostPage'
import ProductDetailPage from '@/components/ProductDetailPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/plugins" element={<ProductsPage />} />
        <Route path="/product/:slug" element={<ProductDetailPage />} />
        <Route path="/wordpress-integration" element={<WordPressIntegrationPage />} />
        <Route path="/elementor-whmcs" element={<ElementorPage />} />
        <Route path="/cpanel-integration" element={<CpanelPage />} />
        <Route path="/discord-notifications" element={<DiscordNotificationPage />} />
        <Route path="/stripe-payment" element={<StripePaymentPage />} />
        <Route path="/crypto-payment" element={<CryptoPaymentPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/dangers-of-nulled-plugins" element={<BlogPostPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
